import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { api, euro } from "@/lib/api";

const COLORS = ["#6B2835", "#A59689", "#211C19", "#8B6b55", "#556B55"];

export default function FinanceDashboard() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/admin/finance").then((r) => setF(r.data)).catch(() => {}); }, []);
  if (!f) return <p className="text-taupe">Caricamento incassi…</p>;

  const kpis = [
    ["Incasso realizzato", euro(f.gross_completed), "servizi completati"],
    ["Ticket medio", euro(f.avg_ticket), `${f.completed_count} servizi`],
    ["Acconti raccolti", euro(f.deposits_collected), "su tutte le prenotazioni"],
    ["Valore in arrivo", euro(f.upcoming_value), `${f.confirmed_count} confermati`],
    ["Da incassare in salone", euro(f.to_collect), "saldi confermati"],
  ];

  return (
    <div className="space-y-10">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {kpis.map(([l, v, s]) => (
          <div key={l} className="border border-espresso/10 bg-offwhite rounded-sm p-5">
            <div className="kima-overline text-taupe">{l}</div>
            <div className="font-serif text-2xl lg:text-3xl text-espresso mt-2">{v}</div>
            <div className="text-xs text-espresso/50 mt-1">{s}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="border border-espresso/10 bg-offwhite rounded-sm p-6">
          <h3 className="font-serif text-2xl text-espresso mb-6">Incasso per categoria</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={f.revenue_by_category} layout="vertical" margin={{ left: 20 }}>
              <XAxis type="number" tick={{ fontSize: 12, fill: "#A59689" }} />
              <YAxis type="category" dataKey="category" width={110} tick={{ fontSize: 12, fill: "#211C19" }} />
              <Tooltip formatter={(v) => euro(v)} cursor={{ fill: "#21201c08" }} />
              <Bar dataKey="revenue" radius={[0, 2, 2, 0]}>
                {f.revenue_by_category.map((e, i) => (<Cell key={i} fill={COLORS[i % COLORS.length]} />))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="border border-espresso/10 bg-offwhite rounded-sm p-6">
          <h3 className="font-serif text-2xl text-espresso mb-6">Andamento incassi (per giorno)</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={f.revenue_by_day}>
              <XAxis dataKey="date" tick={{ fontSize: 10, fill: "#A59689" }} tickFormatter={(d) => d.slice(5)} />
              <YAxis tick={{ fontSize: 12, fill: "#A59689" }} />
              <Tooltip formatter={(v) => euro(v)} cursor={{ fill: "#21201c08" }} />
              <Bar dataKey="revenue" fill="#6B2835" radius={[2, 2, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="border border-espresso/10 bg-offwhite rounded-sm p-6">
        <h3 className="font-serif text-2xl text-espresso mb-6">Servizi venduti</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-taupe border-b border-espresso/10">
              <th className="py-3 font-medium kima-overline">Servizio</th>
              <th className="py-3 font-medium kima-overline text-right">Quantità</th>
              <th className="py-3 font-medium kima-overline text-right">Incasso</th>
            </tr></thead>
            <tbody>
              {f.services_sold.map((s) => (
                <tr key={s.service} className="border-b border-espresso/5">
                  <td className="py-3 text-espresso">{s.service}</td>
                  <td className="py-3 text-right text-espresso/70">{s.count}</td>
                  <td className="py-3 text-right text-espresso font-medium">{euro(s.revenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
